/* eslint-disable no-underscore-dangle */
import { logError } from 'commons/logger';

const handleInsightsAddToCartAndConversion = ({
  hit = {},
  productData = {},
}) => {
  if (window.aa && window.algoliaInitialized) {
    window.aa('addedToCartObjectIDsAfterSearch', {
      eventName: 'Product Added to Cart',
      userToken: window?.rudderanalytics?.getAnonymousId?.() || '',
      index: 'products_jb4',
      objectIDs: [hit.objectID],
      queryId: hit.__queryID,
      objectData: [
        {
          name: productData?.name,
        },
      ],
      value: productData?.price || 0,
      currency: 'USD',
    });
    window.aa('convertedObjectIDsAfterSearch', {
      eventName: 'User Converted After Search',
      userToken: window?.rudderanalytics?.getAnonymousId?.() || '',
      index: 'products_jb4',
      objectIDs: [hit.objectID],
      queryId: hit.__queryID,
    });
  } else {
    logError('Algolia Insights not initialized yet.');
  }
};

export default handleInsightsAddToCartAndConversion;
